<kendo-expansionpanel [title]="'Carrier Team'"
                      [subtitle]=""
                      [expanded]="true">
    <div class="row" *ngFor="let teamType of carrierTeamTypeList;let idx = index;" style="padding-right:15px;">
        <div class="col font-weight-bold">
            {{teamType.description}}
        </div>
        <div class="col">
            <select name="employeeID{{idx}}"
                    class="form-select"
                    (change)="setEmployeeCarrierTeamMap(teamType.carrierTeamTypeID, $event)"
                    [disabled]="!isCSSupervisor">
                <option value="">-- Assign Employee --</option>
                <option *ngFor="let employee of employeeList"
                        value="{{employee.employeeId}}"
                        [selected]="isEmployeeCarrierTeamType(teamType.carrierTeamTypeID, employee.employeeId)">
                    {{employee.fullName}}
                </option>
            </select>
        </div>
    </div>
</kendo-expansionpanel>

<div class="spinner_container dark-overlay" [ngClass]="{'dark-overlay':isLoading}" *ngIf="isLoading">
    <mat-spinner style="left: 50%; top: 50%" *ngIf="isLoading"></mat-spinner>
</div>
